import { View } from 'react-native'
import { SvgXml } from 'react-native-svg'
import { kitSvgSources } from './sources'

type IconProps = { size?: number; color?: string; testID?: string; isSecondary?: boolean }

function createIcon(name: keyof typeof kitSvgSources) {
  const preservesColors = name === 'sbp' || name === 'topup' || name === 'withdraw'
  return function KitIcon({ size = 24, color, testID, isSecondary }: IconProps) {
    const source = kitSvgSources[name]
    let xml = !preservesColors && color ? source.replace(/#18181B|#9F9FA9/gi, color) : source

    if (name === 'topup' && isSecondary && color) xml = source.replace(/fill="url\(#[^)]+\)"/g, `fill="${color}"`)
    return (
      <View testID={testID}>
        <SvgXml xml={xml} width={size} height={size} />
      </View>
    )
  }
}

export const kitIcons = {
  card: createIcon('card'),
  'card-add': createIcon('card-add'),
  placeholder: createIcon('placeholder'),
  check: createIcon('check'),
  'chevron-down': createIcon('chevron-down'),
  'chevron-left': createIcon('chevron-left'),
  'chevron-right': createIcon('chevron-right'),
  clock: createIcon('clock'),
  close: createIcon('close'),
  freeze: createIcon('freeze'),
  help: createIcon('help'),
  'lock-filled': createIcon('lock-filled'),
  lock: createIcon('lock'),
  pin: createIcon('pin'),
  sbp: createIcon('sbp'),
  support: createIcon('support'),
  theme: createIcon('theme'),
  topup: createIcon('topup'),
  withdraw: createIcon('withdraw'),
  'support-headset': createIcon('support'),
}
